import { render, staticRenderFns } from "./ColumnasEditor.vue?vue&type=template&id=6bdf9cb4&scoped=true"
import script from "./ColumnasEditor.vue?vue&type=script&lang=js"
export * from "./ColumnasEditor.vue?vue&type=script&lang=js"
import style0 from "./ColumnasEditor.vue?vue&type=style&index=0&id=6bdf9cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf9cb4",
  null
  
)

export default component.exports